module.exports = __webpack_public_path__ + "static/zwyzka-stalowa-wola-05cc5330634e1e32260402db60d092a5.webp";